<template>
  <div class="cert">
    <div class="cert__no">{{ no }}</div>
    <div class="cert__prize">{{ prize }}</div>
    <div class="cert__prize__en">
      {{prizeEn[prize] || prize}}
    </div>
    <div class="cert__content">
      <div class="cert__winner">{{ winner }} 同学参加2021年 “信息科普活动”</div>
      <div>特发此证，以资鼓励</div>
      <!-- <div class="cert__main">
        <span></span>
        {{ cpName }}
        <span class="cert__step">{{ cpStep }}</span>
        中表现优异，获得
        <span class="cert__city">{{ city }}</span>
      </div> -->
    </div>
    <img class="cert__bg" :src="bgImage" />
  </div>
</template>

<script>
export default {
  props: {
    no: String,
    city: String,
    winner: String,
    cpName: String,
    cpStep: String,
    prize: String,
    bgImage: String,
  },
  data(){
    return{
      prizeEn:{
        '一等奖':'THE FIRST PRIZE',
        '二等奖':'THE SECOND PRIZE',
        '三等奖':'THE THIRD PRIZE',
      }
    }
  },
}
</script>

<style lang="less" scoped>
.cert {
  position: relative;
  width: 2480px;
  height: 3366px;
  line-height: 1;

  &__no {
    position: absolute;
    top: 596px;
    left: 666px;
    font-size: 52px;
    font-family: DIN Alternate;
    font-weight: bold;
    color: rgba(51,51,51,1);
  }

  &__content {
    // padding: 1748px 40px;
    width: 100%;
    position: absolute;
    top:1720px;
    left:50%;
    transform: translate(-50%,0);
    font-size: 90px;
    line-height: 152px;
    font-family: 'STSong','SimSun';
    text-align: center;
    font-weight: 400;
    color: rgba(51,51,51,1);
  }
  &__main {
    margin-top: 56px;
    font-size: 67px;
    font-weight: 400;
    color: rgba(51,51,51,1);
  }

  &__prize {
    position: absolute;
    top: 909px;
    left:50%;
    transform: translate(-50%,0);
    font-size: 400px;
    font-family: 'STSong','SimSun';
    font-weight: 600;
    color: rgba(51,51,51,1);
  }
  &__prize__en{
    position: absolute;
    top: 1400px;
    left:50%;
    transform: translate(-50%,0);
    letter-spacing:22px;
    font-size: 88px;
    font-family: 'STSong','SimSun';
    color:#9F9484;
  }
  &__city{
    position: absolute;
    top:180px;
    left:1050px;
    font-size: 88px;
    font-family: SimSun;
    font-weight: 600;
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
}
</style>
